import { APIKit } from "config/axios/index";
import store from "config/redux/index";
import { start, end } from "config/redux/slice";

import { ServerConstants, ServiceConstants } from "constant";
import { ServiceModel } from "models";
import { ListFilterRequest, ProfileRequest } from "types";

import { handleErrorWithTokenRenewal } from "./common";

const { API_V1_PROFILES } = ServerConstants;
const { 
  REQUEST_PROFILES_LIST_ID,
  REQUEST_PROFILES_CREATE_ID,
  REQUEST_PROFILES_UPDATE_ID,
  REQUEST_PROFILES_DELETE_ID,
  REQUEST_PROFILES_PERMISSIONS_ID,
  REQUEST_PROFILE_AGENT_CREATE_ID,
} = ServiceConstants;

export async function profilesAll(filter: ListFilterRequest) {
  const requestId = REQUEST_PROFILES_LIST_ID;
  try {
    store.dispatch(start(requestId));
    let url = `${API_V1_PROFILES}?page=${filter.page}`;
    if (filter.search) url += `&search=${filter.search}`;
    if (filter.pageSize) url += `&pageSize=${filter.pageSize}`;
    const response = await APIKit.get(url);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, profilesAll, [filter], requestId);
  }
}

export async function profileCreate(data: ProfileRequest) {
  const requestId = REQUEST_PROFILES_CREATE_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(API_V1_PROFILES, data);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, profileCreate, [data], requestId);
  }
}

export async function profileUpdate(id: number, data: ProfileRequest) {
  const requestId = REQUEST_PROFILES_UPDATE_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.put(`${API_V1_PROFILES}/${id}`, data);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, profileUpdate, [id, data], requestId);
  }
}

export async function profileDelete(id: number) {
  const requestId = REQUEST_PROFILES_DELETE_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.delete(`${API_V1_PROFILES}/${id}`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, profileDelete, [id], requestId);
  }
}

export async function profilePermissionsAll() {
  const requestId = REQUEST_PROFILES_PERMISSIONS_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_PROFILES}/permissions`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, profilePermissionsAll, [], requestId);
  }
}

export async function profileAgentCreate(agentId: number, data: ProfileRequest) {
  const requestId = REQUEST_PROFILE_AGENT_CREATE_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_PROFILES}/agent/${agentId}`, data);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, profileAgentCreate, [agentId, data], requestId);
  }
}